import { GridHeaderComponent } from './grid-header.component';
import { KeyValueRowComponent, KeyValueComponent } from './key-value-row.component';
import { KeyValueCard } from './key-value-card.component';

const ASSORTED_COMPONENTS = [
  KeyValueCard,
  KeyValueRowComponent,
  KeyValueComponent,
  GridHeaderComponent
];

export {
  KeyValueCard,
  KeyValueRowComponent,
  KeyValueComponent,
  GridHeaderComponent,
  ASSORTED_COMPONENTS
};



// WEBPACK FOOTER //
// ./src/app/shared/components/assorted/index.ts